import i18n from "i18next";
import backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { localizationResourceGet, localizationResourceAdd } from "./api";
import { jsError } from "./common/utils";
import { absenceNS } from "./mgmtview/personalprofile/newabscencemodal/newabscencemodal.constants";

export const supportedLanguages = ["fi", "sv", "nl", "en"];

const backendOptions = {
  loadPath: "{{lng}}|{{ns}}",
  addPath: "add/{{lng}}|{{ns}}",
  parsePayload: function (namespace, key, fallbackValue) {
    return { key, fallbackValue };
  },
  request: (options, url, payload, callback) => {
    try {
      let add = false;
      if (url.includes("add/")) {
        add = true;
        url = url.replace("add/", "");
      }

      const [lng, ns] = url.split("|");

      // This prevents from loading translations namespace before user has logged in
      //if (ns === "default") {
      // callback(null, {
      //    data: {},
      //    status: 200
      //  });
      //  return;
      //}

      if (add) {
        localizationResourceAdd(lng, ns, payload).then((response) => {
          callback(null, {
            data: response.data,
            status: 200,
          });
        });
      } else {
        localizationResourceGet(lng, ns).then((response) => {
          callback(null, {
            data: response.data,
            status: 200,
          });
        });
      }
    } catch (e) {
      jsError(e);
      callback(null, {
        status: 500,
      });
    }
  },
};

const languageDetectorOptions = {
  order: ["cookie", "localStorage", "navigator"],
  lookupCookie: "locale",
  lookupLocalStorage: "locale",
  caches: ["localStorage", "cookie"],
  excludeCacheFor: ["cimode"],
};

i18n
  .use(backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: backendOptions,
    detection: languageDetectorOptions,
    supportedLngs: supportedLanguages,
    fallbackLng: "fi",
    saveMissing: import.meta.env.DEV,
    ns: ["translations", "grid", absenceNS],
    defaultNS: "translations",
    debug: import.meta.env.DEV,
    load: "languageOnly",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;

// {{field}} {{type}} on the {{tab}} tab (e.g. "OccupationCodeTK10 is required on the EmploymentInfo tab")
export const errorFieldTypeTab = (fieldKey, typeKey, tabKey) =>
  i18n.t("Error.FIELD_TYPE_TAB", {
    field: i18n.t(fieldKey),
    type: i18n.t(typeKey),
    tab: i18n.t(tabKey),
  });
